<template>
  <v-app style="background-color: #f8f9fb">
    <!-- Diálogo de progresso -->
    <v-dialog v-model="showProgress" persistent max-width="300">
      <v-card>
        <v-card-title> Baixando arquivo... </v-card-title>
        <v-card-text>
          <!-- Coloque aqui qualquer indicador de progresso que você deseja mostrar -->
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-container
      style="background-color: #eee"
      id="contrato"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-wallet-outline"
            title="Gestão de Carteira"
            color="green"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-4"
          >
            <v-card class="pa-4 mx-4" elevation="0">
              <v-row>
                <v-col cols="12" sm="6" md="2">
                  <span>Mês de Referência</span>
                  <v-menu
                    v-model="isStartDatePickerOpen"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        v-model="selectedStartDate"
                        label="Mês de Referência"
                        dense
                        solo-inverted
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>

                    <v-date-picker
                      v-model="localSelectedStartDateISO"
                      type="month"
                      no-title
                      @input="handleStartDateSelection"
                      locale="pt-br"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="6" md="2">
                  <span>Data de Corte</span>
                  <v-menu
                    v-model="isDataCortePickerOpen"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    :disabled="!showDataCorte"
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        v-model="selectedDataCorte"
                        label="Data de Corte"
                        dense
                        solo-inverted
                        readonly
                        :disabled="!showDataCorte"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      no-title
                      v-model="localSelectedDataCorteISO"
                      @input="handleDataCorteSelection"
                      locale="pt-br"
                      type="date"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="d-flex align-center">
                  <v-switch
                    v-model="showDataCorte"
                    label="Data de Corte"
                    inset
                    dense
                  ></v-switch>
                </v-col>
              </v-row>

              <v-row class="mt-0">
                <v-col cols="12" md="4">
                  <span>Empresa</span>
                  <v-select
                    v-model="selectedCompany"
                    multiple
                    @input="handleEmpresaSelection"
                    :items="filteredEmpresas"
                    label="Empresa"
                    required
                    dense
                    solo-inverted
                  ></v-select>
                </v-col>

                <v-col cols="12" md="3">
                  <span>Tipo</span>
                  <v-select
                    v-model="selectedTipo"
                    :items="tiposContratos"
                    label="Tipo"
                    required
                    dense
                    solo-inverted
                  ></v-select>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="2" class="d-flex align-center">
                  <v-btn
                    color="primary"
                    block
                    @click="consultarDados()"
                    elevation="2"
                    height="32"
                    class="text-capitalize font-weight-bold"
                  >
                    <v-icon left>mdi-magnify</v-icon>
                    Buscar
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
            <v-card class="pa-4 mx-4" elevation="0">
              <v-expansion-panels v-model="expandedPanels" multiple>
                <v-expansion-panel
                  v-for="(empresa, index) in empresasItems"
                  :key="index"
                >
                  <v-expansion-panel-header class="">
                    <div class="d-flex flex-column w-100">
                      <span class="font-weight-bold">{{ empresa.nome }}</span>
                      <span class="pl-2 pt-2">
                        Total:
                        <v-chip
                          color="primary"
                          text-color="white"
                          class="ml-1"
                          small
                        >
                          R$ {{ somaValores(empresa).toLocaleString("pt-BR") }}
                        </v-chip>
                      </span>
                    </div>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <v-list dense>
                      <template v-for="(plano, pIndex) in empresa.planos">
                        <v-list-item :key="pIndex">
                          <v-list-item-icon class="align-self-center">
                            <v-icon
                              :color="
                                getDiferencaIcon(calcularDiferenca(plano)).color
                              "
                            >
                              {{
                                getDiferencaIcon(calcularDiferenca(plano)).icon
                              }}
                            </v-icon>
                            <span
                              v-if="calcularDiferenca(plano) !== 0"
                              class="ml-1"
                            >
                              {{ Math.abs(calcularDiferenca(plano)) }}
                            </span>
                          </v-list-item-icon>

                          <v-list-item-content>
                            <v-list-item-title class="font-weight-bold my-2">
                              {{ plano.tipoPlano }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <strong>Quantidade:</strong>
                              {{ plano.quantidade }} -
                              <strong>Valor:</strong> R$
                              {{ plano.valor.toLocaleString("pt-BR") }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                              <v-simple-table
                                dense
                                v-if="empresa.showMesesAnteriores"
                              >
                                <template v-slot:default>
                                  <thead>
                                    <tr>
                                      <th>Período</th>
                                      <th class="text-right">Quantidade</th>
                                      <th class="text-right">Valor</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="(
                                        mes, mIndex
                                      ) in plano.mesesAnteriores"
                                      :key="mIndex"
                                    >
                                      <td>{{ formatMesAno(mes.nomeMes) }}</td>
                                      <td class="text-right">
                                        {{ mes.quantidade }}
                                      </td>
                                      <td class="text-right">
                                        R$
                                        {{ mes.valor.toLocaleString("pt-BR") }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>

                        <v-divider class="my-1"></v-divider>
                      </template>
                    </v-list>

                    <!-- Botão -->
                    <v-btn
                      small
                      outlined
                      class="mt-2"
                      @click="ativar(empresa.nome)"
                    >
                      {{
                        empresa.showMesesAnteriores
                          ? "Esconder meses anteriores"
                          : "Ver meses anteriores"
                      }}
                    </v-btn>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels></v-card
            >
            <br />
            <div class="d-flex justify-end">
              <div style="width: 240px" class="d-flex justify-end pr-4">
                <span
                  @click="download_xls"
                  style="
                    color: green;
                    font-size: 48px;
                    margin-right: 12px;
                    cursor: pointer;
                  "
                >
                  <i class="fas fa-file-excel"></i>
                </span>
                <!-- <span
                  @click="exportToPDF"
                  style="
                    color: red;
                    font-size: 48px;
                    margin-right: 12px;
                    cursor: pointer;
                  "
                >
                  <i class="fas fa-file-pdf"></i>
                </span> -->
              </div>
            </div>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import { http } from "../../services/config";
import authHeader from "../../services/auth-header";
import downloadBlob from "../../services/downloadBlob";

console.log(http);
console.log(authHeader());

export default {
  name: "GestaodeCarteira",
  data() {
    return {
      showProgress: false,
      expandedPanels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],

      isStartDatePickerOpen: false,
      isEndDatePickerOpen: false,
      isDataCortePickerOpen: false,
      showDataCorte: false,

      selectedStartDate: "",
      selectedEndDate: "",
      selectedDataCorte: "",

      localSelectedStartDateISO: null,
      localSelectedEndDateISO: null,
      localSelectedDataCorteISO: null,

      selectedCompany: ["Todas"],
      selectedTipo: "Mensalidades Existentes",
      tiposContratos: ["Mensalidades Existentes", "Novas no Ano"],
      empresas: [
        "CEMITERIO PREVIDA",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DAS FLORES",
        "PARQUE DO AGRESTE",
        "PREVIDA",
        "A FLOR DO CAFÉ",
        "CEMITERIO PREVIDA SÃO MIGUEL",
        "Todas",
      ],
      showMesesAnteriores: false,
      empresasItems: [],
    };
  },

  computed: {
    filteredEmpresas() {
      return this.empresas.filter((empresa) => this.hasPermission(empresa));
    },
  },
  mounted() {
    this.consultarDados();
  },
  methods: {
    calcularDiferenca(plano) {
      if (!plano.mesesAnteriores || plano.mesesAnteriores.length === 0) {
        return 0;
      }
      const mesAnterior = plano.mesesAnteriores[0];
      return plano.quantidade - mesAnterior.quantidade;
    },
    consultarDados() {
      const empresas = this.selectedCompany.join(",");
      let tipo = "";

      switch (this.selectedTipo) {
        case "Mensalidades Existentes":
          tipo = "existente";
          break;
        case "Novas no Ano":
          tipo = "novosAno";
          break;
      }

      http
        .get("/carteira-dash/mensalidades-existentes", {
          headers: authHeader(),
          params: {
            "data-referencia": this.localSelectedStartDateISO,
            "data-corte": this.localSelectedDataCorteISO,
            empresa: empresas,
            tipo: tipo,
          },
        })
        .then((response) => {
          this.empresasItems = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    somaValores(empresa) {
      return empresa.planos.reduce((total, plano) => total + plano.valor, 0);
    },
    download_xls() {
      const empresas = this.selectedCompany.join(",");
      let tipo = "";
      this.showProgress = true;
      switch (this.selectedTipo) {
        case "Mensalidades Existentes":
          tipo = "existente";
          break;
        case "Novas no Ano":
          tipo = "novosAno";
          break;
        case "Novas no Mês":
          tipo = "novosMes";
          break;
      }

      http
        .get("/carteira-dash/mensalidades-existentes-xls", {
          headers: authHeader(),
          params: {
            "data-referencia": this.localSelectedStartDateISO,
            "data-corte": this.localSelectedDataCorteISO,
            empresa: empresas,
            tipo: tipo,
          },
          responseType: "arraybuffer",
        })
        .then((response) => {
          const fileName = `carteira_${Date.now()}.xlsx`;
          downloadBlob(new Blob([response.data]), fileName);
        })
        .catch(() => {
          alert("Erro ao baixar o arquivo Excel.");
        })
        .finally(() => (this.showProgress = false));
    },
    ativar(nomeEmpresa) {
      const empresaIndex = this.empresasItems.findIndex(
        (e) => e.nome === nomeEmpresa
      );
      if (empresaIndex !== -1) {
        const empresa = this.empresasItems[empresaIndex];
        console.log(`Antes: ${empresa.showMesesAnteriores}`);
        this.$set(empresa, "showMesesAnteriores", !empresa.showMesesAnteriores);
        console.log(`Depois: ${empresa.showMesesAnteriores}`);
      }
    },
    getDiferencaIcon(diferenca) {
      if (diferenca > 0) {
        return { icon: "mdi-arrow-up-bold", color: "green" };
      } else if (diferenca < 0) {
        return { icon: "mdi-arrow-down-bold", color: "red" };
      } else {
        return { icon: "mdi-minus", color: "grey" };
      }
    },
    handleEmpresaSelection() {
      if (this.selectedCompany.includes("Todas")) {
        this.selectedCompany = ["Todas"];
      }
    },

    hasPermission(empresa) {
      this.user = JSON.parse(sessionStorage.getItem("user"));

      if (this.user.roles.includes("ROLE_ADMIN")) {
        return true;
      } else if (empresa === "Todas") {
        return true;
      } else {
        const requiredRoles = empresa
          .split(",")
          .map(
            (name) => "ROLE_" + name.trim().toUpperCase().replace(/\s/g, "_")
          );

        const hasAnyRequiredRole = requiredRoles.some((role) =>
          this.user.roles.includes(role)
        );
        return hasAnyRequiredRole;
      }
    },

    handleStartDateSelection() {
      this.selectedStartDate = this.formatMonthYear(
        this.localSelectedStartDateISO
      );
      this.isStartDatePickerOpen = false;
    },

    handleDataCorteSelection() {
      this.selectedDataCorte = this.convertToBR(this.localSelectedDataCorteISO);
      this.isDataCortePickerOpen = false;
    },

    convertToBR(dateString) {
      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    },

    formatMonthYear(dateString) {
      const [year, month] = dateString.split("-");
      return `${month}/${year}`;
    },
    formatMesAno(dateString) {
      // Extract the first date from the range (e.g., "2025-03-01" from "2025-03-01 - 2025-03-31")
      const firstDate = dateString.split(" - ")[0];
      const [year, month] = firstDate.split("-");
      return `${month}/${year}`;
    },
  },
  watch: {
    showDataCorte(newValue) {
      if (!newValue) {
        // When switch is turned off, set data corte to last day of selected month
        const [year, month] = this.localSelectedStartDateISO.split("-");
        const lastDay = new Date(parseInt(year), parseInt(month), 0).getDate();
        this.localSelectedDataCorteISO = `${year}-${month}-${String(
          lastDay
        ).padStart(2, "0")}`;
        this.selectedDataCorte = this.convertToBR(
          this.localSelectedDataCorteISO
        );
      }
    },
    localSelectedStartDateISO(newValue) {
      if (!this.showDataCorte) {
        // When switch is off, update data corte to last day of selected month
        const [year, month] = newValue.split("-");
        const lastDay = new Date(parseInt(year), parseInt(month), 0).getDate();
        this.localSelectedDataCorteISO = `${year}-${month}-${String(
          lastDay
        ).padStart(2, "0")}`;
        this.selectedDataCorte = this.convertToBR(
          this.localSelectedDataCorteISO
        );
      }
    },
  },
  created() {
    const today = new Date();
    const previousMonth = new Date(today.getFullYear(), today.getMonth() - 1);

    // Format as YYYY-MM
    const previousMonthStr = `${previousMonth.getFullYear()}-${String(
      previousMonth.getMonth() + 1
    ).padStart(2, "0")}`;

    // Set month reference
    this.localSelectedStartDateISO = previousMonthStr;
    this.selectedStartDate = this.formatMonthYear(previousMonthStr);

    // Set data corte to last day of previous month
    const lastDay = new Date(
      previousMonth.getFullYear(),
      previousMonth.getMonth() + 1,
      0
    ).getDate();
    const dataCorteStr = `${previousMonthStr}-${String(lastDay).padStart(
      2,
      "0"
    )}`;
    this.localSelectedDataCorteISO = dataCorteStr;
    this.selectedDataCorte = this.convertToBR(dataCorteStr);
  },
};
</script>
